import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingGetStartedAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-get-started/src/helpCenterSettingGetStartedAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { getStartedPropertyResource } from '@jira/router-resources__service-desk-customer-service-get-started-property/src/getStartedPropertyResource.tsx';
import { serviceDeskIncomingEmailResource } from '@jira/router-resources__service-desk-incoming-email/src/serviceDeskIncomingEmailResource.tsx';
import { firstProjectResource } from '@jira/router-resources__service-desk-project-getting-started/src/firstProjectResource.tsx';
import { csmWidgetLayout } from '@jira/customer-service__csm-support-widget-layout/src/csmWidgetLayout.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { csmExperienceGetStartedRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceGetStartedRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupSupportWebsiteResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import {
	composeLayouts,
	layoutWithCondition,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceGetStartedPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceGetStartedRouteEntry: Route = createEntry(
	csmExperienceGetStartedRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-get-started',
		layout: layoutWithCondition(
			() => fg('csm-support-widget-in-csm'),
			composeLayouts(serviceProjectLayout, csmWidgetLayout),
			serviceProjectLayout,
		),
		navigation: {
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceGetStartedPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			firstProjectResource,
			getStartedPropertyResource,
			resourceWithCondition(() => fg('csm_ai_onboarding_tasks'), csmHubSetupSupportWebsiteResource),
			resourceWithCondition(() => fg('csm_ai_onboarding_tasks'), serviceDeskIncomingEmailResource),
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
